module.exports = __webpack_public_path__ + "static/img/download.b377cbb9.gif";